// VA-28022 / VA-28036: marks are stored to one decimal (the backend's
// ScoreEngine rounds earned marks to 1 dp). Rounding them to whole numbers
// on the report made the headline disagree with the interview list (79.9 vs
// 80) and made the per-criterion marks add up to more than the headline.
// Every earned-marks / final-score figure goes through this one formatter.
/** Marks to one decimal, dropping a trailing ".0" (79.9, 80, 6.8). */
export function formatMarks(value) {
    if (value == null || !Number.isFinite(value))
        return '—';
    const rounded = Math.round(value * 10) / 10;
    return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
}
